export default __webpack_public_path__ + "static/media/02.09.090.309fc155.png";